export enum Permission {
  // OST creación
  CREATE_OST_LEGAL_MT = "CREATE_OST_LEGAL_MT",
  CREATE_OST_GATEX_MT = "CREATE_OST_GATEX_MT",
  CREATE_OST_GATEX_BT = "CREATE_OST_GATEX_BT",
  CREATE_OST_CONNECT_DANO = "CREATE_OST_CONNECT_DANO",
  CREATE_OST_CONNECT_ROBO = "CREATE_OST_CONNECT_ROBO",
  BULK_UPLOAD_OST = "BULK_UPLOAD_OST",
  CREATE_OST_3P = "CREATE_OST_3P",

  // Giftcards
  CREATE_GC_GATEX_BT = "CREATE_GC_GATEX_BT",
  CREATE_GC_GATEX_MT = "CREATE_GC_GATEX_MT",
  CREATE_GC_CONNECT = "CREATE_GC_CONNECT",

  // Vista
  VIEW_OST_HISTORY = "VIEW_OST_HISTORY",
  VIEW_ASSETS = "VIEW_ASSETS",
  VIEW_OST_LEGAL_MT = "VIEW_OST_LEGAL_MT",
  VIEW_OST_GATEX_MT = "VIEW_OST_GATEX_MT",
  VIEW_OST_GATEX_BT = "VIEW_OST_GATEX_BT",
  VIEW_OST_CONNECT_DANO = "VIEW_OST_CONNECT_DANO",
  VIEW_OST_CONNECT_ROBO = "VIEW_OST_CONNECT_ROBO",
  VIEW_ALL_OST = "VIEW_ALL_OST",
  VIEW_OST_DETAILED_HISTORY = "VIEW_OST_DETAILED_HISTORY",
  VIEW_DELIVERY_EVIDENCE = "VIEW_DELIVERY_EVIDENCE",

  // Gestión
  JUMP_SUBSTATE_STORE_PRODUCT = "JUMP_SUBSTATE_STORE_PRODUCT",
  ATTACH_FILE_OST = "ATTACH_FILE_OST",
  DOWNLOAD_OST_REPORT = "DOWNLOAD_OST_REPORT",
  CHANGE_SUBSTATE_OST = "CHANGE_SUBSTATE_OST",
  ACCESS_FORM = "ACCESS_FORM",
  MANAGE_PRODUCT = "MANAGE_PRODUCT",
  AUTHORIZE_SUPPLIER_INVOICING = "AUTHORIZE_SUPPLIER_INVOICING",
  RESEND_GC_UPDATE_EMAIL = "RESEND_GC_UPDATE_EMAIL",
  EDIT_RETROVENTA_NOTES = "EDIT_RETROVENTA_NOTES",
  RETRY_MAIL_LABEL = "RETRY_MAIL_LABEL",
  REGISTER_MANUAL_MAIL_LABEL = "REGISTER_MANUAL_MAIL_LABEL",

  // Complementarios
  ADMIN_ALL = "ADMIN_ALL",
  MANAGE_USERS = "MANAGE_USERS",
  VIEW_LABELS = "VIEW_LABELS",
  VIEW_EXCEL_UPLOAD = "VIEW_EXCEL_UPLOAD",
}
